import React from 'react'
import PropTypes from 'prop-types'
import { CX } from '../constants'
import Text from './text'

class Textarea extends React.PureComponent {

  state = {
    stateHasError: this.props.hasError,
    isFocused: false
  }

  componentDidUpdate(prevProps) {
    const { value, hasError } = this.props
    if (prevProps.value !== value) {
      this.setState({ stateValue: value })
    }
    if (prevProps.hasError !== hasError) {
      this.setState({ stateHasError: hasError })
    }
  }

  handleOnChange = (e) => {
    const { value } = e.target
    this.props.onChange && this.props.onChange(value)
    if (this.state.stateHasError) this.setState({ stateHasError: false })
  }

  handleOnFocus = () => {
    this.setState({ isFocused: true })
    this.props.onFocus && this.props.onFocus()
  }

  handleOnBlur = () => {
    this.setState({ isFocused: false })
    this.props.onBlur && this.props.onBlur()
  }


  render() {
    const {
      placeholder,
      prependIcon,
      value,
      onKeyUp,
      onFocus,
      onBlur,
      title,
      isRequired,
      maxLength,
      isDisabled,
      className,
      rows,
    } = this.props
    const { stateHasError, isFocused } = this.state

    const inputClasses = CX(className, {
      d: 1,
      text: 1,
      outlineNone: 1,
      lineHeight125: 1,
      displayBlock: 1,
      py10: 1,
      bgTransparent: 1,
      fs16PX: 1,
      flexGrow1: 1,
      maxH100VH: 1,
      resizeVertical: 1,
      cPrimary: 1,
      minH106PX: !className,
      px5: !!prependIcon,
      pl15: !prependIcon,
      cursorNotAllowed: isDisabled,
    })

    const containerClasses = CX({
      d: 1,
      bgPrimary: 1,
      border1PX: 1,
      flexRow: 1,
      radiusTiny: 1,
      aiCenter: 1,
      borderColorInput: !stateHasError,
      borderColorError: stateHasError,
      borderColorInputFocused: isFocused,
      outlineBrand: isFocused,
    })

    return (
      <div>
        {
          !!title &&
          <div className={[_s.d, _s.mb5, _s.pb5].join(' ')}>
            <Text weight='medium' color='primary'>
              {title}
            </Text>
          </div>
        }
        <div className={containerClasses}>
          <textarea
            className={inputClasses}
            type='text'
            rows={rows}
            placeholder={placeholder}
            value={value}
            onChange={!isDisabled ? this.handleOnChange : undefined}
            onKeyUp={!isDisabled && !!onKeyUp ? onKeyUp : undefined}
            onFocus={!isDisabled ? this.handleOnFocus : undefined}
            onBlur={!isDisabled ? this.handleOnBlur : undefined}
            maxLength={maxLength}
            disabled={isDisabled}
            required={isRequired ? true : undefined}
          />

        </div>
      </div>
    )
  }
}

Textarea.propTypes = {
  placeholder: PropTypes.string,
  prependIcon: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  title: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  maxLength: PropTypes.number,
  rows: PropTypes.number,
  className: PropTypes.string,
}

Textarea.defaultProps = {
  rows: 1,
}

export default Textarea